import cx from "classnames"
import styles from "./Section.module.scss"

// include the deprecated Background Fill for now
export const parseColors = ({ colors, fillBg }) => {
  if (!Array.isArray(colors)) return { accent: {}, background: {} }

  const background = colors?.[0]
  const accent = colors?.[1]
  const secondaryAccent = colors?.[2]
  const backgroundColor = background?.value
  const accentColor = accent?.value
  const secondaryAccentColor = secondaryAccent?.value
  const bgColor = fillBg
    ? accentColor
    : !background?.isAsPage
    ? backgroundColor
    : "transparent"
  const isLightBackground =
    (["white"].includes(accent?.name) && fillBg) ||
    (!fillBg && ["white"].includes(background?.name))

  return {
    accent: { color: accentColor, name: accent?.name },
    secondaryAccent: {
      color: secondaryAccentColor,
      name: secondaryAccent?.name,
    },
    background: {
      color: bgColor,
      name: fillBg ? accent?.name : background?.name,
    },
    fontColor:
      bgColor === "transparent"
        ? "inherit"
        : isLightBackground
        ? "black"
        : "white",
    isLightBackground,
  }
}

export const Section = ({
  children,
  className = "",
  containerClassName = "",
  data = {},
  colors,
  style = {},
  sectionSpacing = {
    top: null,
    bottom: null,
  },
  noPadding = false,
  noContainer = false,
  outsideContainer,
  ...rootProps
}) => {
  // console.log("Section", sectionSpacing)
  const { text_image_fill_background, text_video_fill_background } = data
  const fillBg = text_image_fill_background || text_video_fill_background

  if (sectionSpacing.top === null) {
    sectionSpacing.top = "medium"
  }

  if (sectionSpacing.bottom === null) {
    sectionSpacing.bottom = "medium"
  }

  const { accent, background, fontColor } = parseColors({ colors, fillBg })

  return (
    <section
      data-s-top={sectionSpacing.top}
      data-s-bottom={sectionSpacing.bottom}
      style={{
        backgroundColor: background.color,
        color: fontColor,
        "--accent-color": accent.color,
        ...style,
      }}
      className={cx(
        styles.Section,
        {
          [styles[`paddingTop-${sectionSpacing.top}`]]:
            !noPadding && sectionSpacing.top,
          [styles[`paddingBottom-${sectionSpacing.bottom}`]]:
            !noPadding && sectionSpacing.bottom,
        },
        className
      )}
      {...rootProps}
    >
      {children ? (
        <div
          className={cx(containerClassName, {
            container: !noContainer,
          })}
        >
          {children}
        </div>
      ) : null}
      {outsideContainer}
    </section>
  )
}

export default Section
